import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { Role } from '../main/models/role-model';
import RedirectPage from '../main/pages/redirect-page';
import { ControlPanelContainer } from './containers/control-panel-container';
import { controlPanelRoutePaths } from './models/path-model';

const CyclesPage = React.lazy(() => import('./pages/cycles-page'));
const CategoriesPage = React.lazy(() => import('./pages/categories-page'));
const EvaluatorsPage = React.lazy(() => import('./pages/evaluators-page'));

export const controlPanelRoutes: Sebrae.RoutesConfig = [
  {
    routePath: controlPanelRoutePaths.home,
    pageToRender: <RedirectPage route={controlPanelRoutePaths.cycles} />,
    ifHaveTheseRoles: [Role.admin],
  },
  {
    routePath: controlPanelRoutePaths.cycles,
    pageToRender: (
      <ControlPanelContainer>
        <CyclesPage />
      </ControlPanelContainer>
    ),
    ifHaveTheseRoles: [Role.admin],
  },
  {
    routePath: controlPanelRoutePaths.categories,
    pageToRender: (
      <ControlPanelContainer>
        <CategoriesPage />
      </ControlPanelContainer>
    ),
    ifHaveTheseRoles: [Role.admin],
  },
  {
    routePath: controlPanelRoutePaths.evaluators,
    pageToRender: (
      <ControlPanelContainer>
        <EvaluatorsPage />
      </ControlPanelContainer>
    ),
    ifHaveTheseRoles: [Role.admin],
  },
];
